import {
    AfterViewInit,
    Component,
    DoCheck,
    EventEmitter,
    Inject,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {FileToDownload} from '../../model/file-to-download';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {Project} from '../../model/project';
import {AddFileToDownloadComponent} from '../../addFileDownload/add-file-to-download.component';
import {Email} from '../../model/email/email';
import {ThirdPartyShare} from '../../model/social-sharing/thirdPartyShare';
import {Facebook} from '../../model/social-sharing/facebook';
import {Twitter} from '../../model/social-sharing/twitter';
import {Download} from '../../model/social-sharing/download';
import {Questionnaire} from '../../model/questionnaire';
import {ProjectService} from '../project.service';
import {EmailBanner} from '../../model/email/emailBanner';
import {TextMessage} from '../../model/email/TextMessage';
import {SocialMedia} from '../../model/social-sharing/socialMedia';
import {EmailImage} from '../../model/email/emailImage';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ExternalLink} from '../../model/social-sharing/externalLink';
import {Terminal} from '../../model/terminal';
import {DOCUMENT} from '@angular/common';
import {MaterialChipsInputComponent} from '../tags/materialChipsInput.component';
import {TSMap} from 'typescript-map';
import {ValidationService} from '../../service/validation-service';
import {ServerAddress} from '../../util/server-address';
import {Json2TypescriptUtil} from '../../util/json2TypescriptUtil';
import {Attachment} from '../../model/email/attachment';
import {MultipleCondition} from '../../model/Conditions/MultipleCondition';
import {QuestionCondition} from '../../model/Conditions/QuestionCondition';
import {BooleanOperator} from '../../model/Conditions/BooleanOperator';

@Component({

    selector: 'create-email-dialog',
    styles: [
        `
        ::-webkit-scrollbar {
          width: 14px;
          height: 5px;
          background-color: #F5F3F0;
        }
        ::-webkit-scrollbar-thumb {
          height: 6px;
          border: 4px solid rgba(0, 0, 0, 0);
          background-clip: padding-box;
          -webkit-border-radius: 7px;
          background-color:#BACEFF;
          -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
        }
        ::-webkit-scrollbar-button {
          width: 14px;
          height: 14px;
          display: none;
        }
        ::-webkit-scrollbar-corner {
          background-color: transparent;
        }




        .mailWindow{height:40px;margin-top:-5px;}
        .modal-title{padding-left:3%;}
    .modal-dialog {
        width: 50%;
        margin:  auto;
    }
    .modal-body{padding-left:50px; padding-right:50px; overflow-y:scroll; height:600px;}
    .modal-footer{
        border-top:groove;
        background-color:#ECE8E5;
    }
    .ContentSection{ padding-left: 20px;}

    .sectionTitle{font-size: large; font-weight: bold;}

    .mainTable{margin-left: 20px;}
    .borderGray{
        border: 1px solid #ccc;
    }
    .collapse{
      margin-top: 5px;
      border: 1px dashed #1c71ff;
    }
    .innerCollapse{margin-left: 5px;margin-right:5px;margin-bottom: 5px;}
    #btnRemoveAccordion{float:right;}

    .borderRed{
        border: 1px solid red;
    }
            .mainTable {width:100%;}
            .twitterTable{
                margin-left: 20px;
            }
            .downloadSection{
             margin-left: 20px;
            }
            .facebookTable{
                margin-left: 20px;
            }
    .btn.btn-success {
      color: #ffffff;
      background-color: #5CB85C;
      background-image: linear-gradient(to bottom, #5CB85C, #419641);
      border-color: #3E8F3E #3E8F3E #3E8F3E;
    }
    .btn.btn-success:hover {
      color: #ffffff;
      background-color: #419641;
      background-image: linear-gradient(to bottom, #419641, #419641);
      border-color: #3E8F3E #3E8F3E #3E8F3E;
    }
    .baseForm{ width:100%}
    .child-float-left{float: left;}
    .savedEmailBckImage{padding-left: 30%;}

        .modal-dialog {
          max-width: 1900px;
          margin: 50px auto auto;
          background-color: #0064FE;
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
        }

        .modal-header {
          height:56px;
          background-image: url("../../../assets/images/headerBack.jpg");
          color: #ECE8E5;
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
        }
        .modal-content{
          border-top-right-radius: 18px;
          border-top-left-radius: 18px;
          padding-left: 3px;
          padding-right: 3px;
          background-color: #0064FE;
          padding-bottom: 3px;
        }

        .modalBodyContainer{
          background-color:  #ECE8E5;
        }
        .closeX{color:azure;size:25px;}
        .btn-outline-danger {
          background-color: #d6462e;
          border-style: solid;
          border-color: white;
          border-width: 2px;
          padding: 0;
        }
        .closeIcon:hover{ width: 32px;background-image: url("../../../assets/images/closeBtnHovered.png");}

        .closeIcon{ width: 32px;background-image: url("../../../assets/images/closeBtn.png");}
        .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
        .btn-danger:hover{background-color: #FF2400;}
        .alert{font-weight: bold;color: red;font-size: 15px;margin-left:-20px;}
        .exclamation{margin-right:5px;}
        `
    ],
    template: `
      <div class="modal" [style.display]="!hide ? 'inline' : 'none'" style="margin : 20px;" tabindex="-1" role="dialog"  aria-hidden="true">
        <div class="modal-dialog modal-lg"  role="document">
          <div class="modal-content">
            <!-- header-->
            <div class="modal-header">
                <h4><img class="mailWindow" src="../../assets/images/outlookIcon.png"></h4>
              <h4 class="modal-title">Content Definition</h4>
              <!--<button (click)="hideDialog()" type="button" class="close">&times;</button>-->
                <h4 class="closeBtnH4"><button (click)="hideDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                    <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../../assets/images/closeBtn.png"></span>
                </button></h4>
            </div>
            <div class="modalBodyContainer">
              <div class="modal-body">
                <!-- Texts -->
                <div class="row" style="margin-top:20px;">
                  <!--<div class="col-md-6">
                         <div *ngIf="_file != null">{{_file.name}}</div>
                         <input [attr.disabled]="fileToDownload.type != null ? null : ''" type="file" (change)="fileSelected($event)"  style="display:none;" accept="image/*"/>-->
                  <form class="baseForm" [formGroup]=this.getEmailFormRef()>
                    <div class="form-group">
                      <div class="card col-md-12">
                        <div class="card-body">
                      <div class="sectionTitle">Language</div>
                      <div class="ContentSection">
                         <div class="mat-app-background basic-container">
                            <material-chips-input (reload)="loadEmailFormFromEmailModel($event)">loading</material-chips-input>
                             <p *ngIf="this.emailLanguage==null || this.emailLanguage.length===0" class="alert"><span class="exclamation"><i class="fas fa-exclamation-circle"></i></span>Define and select a language before creating your email content.</p>
                         </div>
                      </div>
                      <div class="sectionTitle">Template</div>
                      <div class="ContentSection">
                        <table>
                          <tr>
                            <td><label class="radio-inline">Default</label>
                              <input type="radio" name="template" formControlName="template" class="form-control" value="style1">
                            </td>
                            <td>
                              <label class="radio-inline">Custom</label>
                              <input type="radio" name="template" formControlName="template" class="form-control" value="style2"></td>
                          </tr>
                        </table>
                      </div>
                      <div class="sectionTitle">Email-Background</div>
                      <div class="ContentSection">
                        <table>
                          <tr>
                            <td><input class="backgroundColorRadio" [checked]=this.bckSolidColor type="radio" name="emailBck"  value="bgColor" (click)="toggleEmailBckOption()"></td>
                            <td>Background-Color</td>
                            <ng-container *ngIf="bckSolidColor">
                                <td style="padding-left: 20px;"><input style="width:100px;" type="color" formControlName="bgColor" class="form-control">
                              </td>
                            </ng-container>
                          </tr>
                          <tr>
                            <td><input class="backgroundImageRadio" [checked]=!this.bckSolidColor type="radio" name="emailBck"  value="bgImg" (click)="toggleEmailBckOption()"></td>
                            <td>Background-Image</td>
                            <ng-container *ngIf="!bckSolidColor">
                              <td style="padding-left: 20px;">
                                <input type="file" class="form-control" name="single"  formControlName="bgImg" ng2FileSelect [uploader]="uploader"/>
                              </td>
                              <ng-container *ngFor="let item of uploader.queue">
                                <td>
                                  <span><strong>{{ item?.file?.size / 1024 / 1024 | number:'.2' }} MB</strong></span>
                                </td>
                              </ng-container>
                            </ng-container>
                          </tr>
                          <tr *ngIf="this.email.background_image!=null">
                                  {{ this.email.background_image }}
                          </tr>
                        </table>
                      </div>
                      <div class="sectionTitle">Email-Expediter</div>
                      <div class="ContentSection">
                        <table>
                          <tr>
                            <td>Expediter Address</td>
                            <td style="padding-left:20px"><input style="width: fit-content" type="text" name="emailExpediter" formControlName="emailExpediter" class="form-control"></td>
                          </tr>
                        </table>
                      </div>
                      <div class="sectionTitle">Email-Subject</div>
                      <div class="ContentSection">
                        <table>
                          <tr>
                            <td>Email Subject</td>
                            <td style="padding-left:20px"><input style="width: fit-content" type="text" name="emailSubject" formControlName="emailSubject" class="form-control"></td>
                          </tr>
                        </table>
                      </div>
                      </div>
                      </div>
                    </div>
                  </form>
                </div>
                  <br/>
                  <div class="row">
                      <div class="sectionTitle">Email Content Dimensions</div>
                      <form class="baseForm" [formGroup]=this.getEmailDimensionsFormRef()>
                          <div class="form-group">
                              <div class="card col-md-12">
                                  <div class="card-body">
                                          <div class="input-group mb-3">
                                              <span class="input-group-text" id="basic-addon7">Overall Email Width</span>
                                              <input type="number" formControlName="overallEmailWidth" placeholder="eg:250" class="form-control" id="basic-url2" aria-describedby="basic-addon7">
                                          </div>
                                          <div class="form-group">
                                              <label>Image Dimensions</label>
                                              <div>
                                                  <div class="input-group mb-3">
                                                      <span class="input-group-text" id="basic-addon3">Width</span>
                                                      <input type="number" formControlName="emailImageWidth" placeholder="eg:250" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                                                  </div>
                                                  <div class="input-group mb-3">
                                                      <span class="input-group-text" id="basic-addon4">Height</span>
                                                      <input type="number" formControlName="emailImageHeight" placeholder="eg:250" class="form-control" id="basic-url2" aria-describedby="basic-addon4">
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="input-group mb-3">
                                              <span class="input-group-text" id="basic-addon6">Text Paragraph Side Margin</span>
                                              <input type="number" formControlName="emailTextPargrMargin" placeholder="eg:250" class="form-control" id="basic-url2" aria-describedby="basic-addon6">
                                          </div>
                                          <div class="input-group mb-3">
                                              <span class="input-group-text" id="basic-addon7">Respondent Image Max. Width</span>
                                              <input type="number" formControlName="respondentPictureMaxWidth" placeholder="eg:250" class="form-control" id="basic-url2" aria-describedby="basic-addon7">
                                          </div>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
                  <br/>
                <div class="row">
                  <div class="sectionTitle">Banners</div>
                  <div class="card col-md-12">
                    <div class="card-body">
                  <button data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false"
                          aria-controls="collapseExample" type="button" class="btn btn-success">Manage Banners
                  </button>
                  <div class="collapse" id="collapseExample">
                    <input type="file" class="form-control" name="single" ng2FileSelect [uploader]="uploader"/><br/>
                    <table class="table">
                      <thead class="thead-dark">
                      <tr>
                        <th>Uploaded File</th>
                        <th>Size</th>
                        <th>Placement</th>
                        <th>Action</th>
                      </tr>
                      </thead>
                      <tr *ngFor="let item of uploader.queue">
                        <td><strong>{{ item?.file?.name }}</strong></td>
                        <td>{{ item?.file?.size / 1024 / 1024 | number:'.2' }} MB</td>
                        <td>
                          <div>
                            <div class="child-float-left"><input type="text" class="form-control" value="{{emailBannerContent.get(item?.file?.name)}}" style="width:140px;"></div>
                              <div class="child-float-left dropdown">
                                <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                  <a class="dropdown-item" (click)="onBannerSelected(item,'Top')">Top</a>
                                  <a class="dropdown-item" (click)="onBannerSelected(item,'Above Content')">Above Content</a>
                                  <a class="dropdown-item" (click)="onBannerSelected(item,'Below Content')">Below Content</a>
                                  <a class="dropdown-item" (click)="onBannerSelected(item,'Bottom')">Bottom</a>
                                </div>
                              </div>
                          </div>
                        </td>
                        <td>
                          <button type="button" class="btn btn-danger btn-sm" (click)="removeBannerFromUploaderQueue(item)">Remove</button>
                        </td>
                      </tr>
                      <tr *ngFor="let banner of this.email.emailBanners">
                        <td>{{banner.bannerName}}</td>
                        <td>{{banner.size}} bytes</td>
                        <td>
                          <div class="dropdown">
                            <button class="btn btn-outline-success dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                              {{banner.position}}
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item" (click)="onBannerPositionChanged(banner,'Top')">Top</a>
                              <a class="dropdown-item" (click)="onBannerPositionChanged(banner,'Above Content')">Above Content</a>
                              <a class="dropdown-item" (click)="onBannerPositionChanged(banner,'Below Content')">Below Content</a>
                              <a class="dropdown-item" (click)="onBannerPositionChanged(banner,'Bottom')">Bottom</a>
                            </div>
                          </div>
                        </td>
                        <td>
                          <button type="button" class="btn btn-danger btn-sm" (click)="removeBannerFromEmailBannerContent(banner)">Remove</button>
                        </td>
                      </tr>
                    </table>
                  </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                    <div class="sectionTitle">Email-Media-Content</div>
                  <div class="card col-md-12">
                    <div class="card-body">
                      <button data-toggle="collapse" href="#emailMediaContent" role="button" aria-expanded="false"
                              aria-controls="emailMediaContent" type="button" class="btn btn-info ">Manage Media Content
                      </button>
                      <div class="collapse" id="emailMediaContent">
                        <button type="button" class="btn btn-success btn-sm" (click)="onEmailAddMediaContent()">
                          <span><i class="fas fa-plus"></i></span>
                        </button>
                            <div class="card mb-0" *ngFor="let mediaKey of this.mediaContent.keys()">
                            <div class="card-header collapsed" data-toggle="collapse" >
                              <a class="btn btn-primary btn-sm" data-toggle="collapse" href="#{{mediaKey}}">
                                <h6>
                                  Media Content
                                </h6>
                              </a>
                              <button id="btnRemoveAccordion" (click)="onEmailRemoveMediaContent(mediaKey)" type="button"
                                      class="btn btn-outline-danger btn-sm">Remove
                              </button>
                            </div>
                            <div id="{{mediaKey}}" class="innerCollapse collapse">
                              <div class="card card-body">
                                <form [formGroup]=this.getMediaFormRef(mediaKey)>
                                  <div class="form-group">
                                    <label>Question Number</label>
                                    <input type="text" formControlName="questionNo" class="form-control"/>
                                    <!--<control-message [control]="this.getMediaFormRef(media.key).controls.questionNo"></control-message>-->
                                  </div>
                                  <div class="form-group">
                                    <label>Choice Number</label>
                                    <input type="text" formControlName="choiceNo" class="form-control"/>
                                    <!--<control-message [control]="this.getMediaFormRef(media.key).controls.choiceNo"></control-message>-->
                                  </div>
                                  <div class="form-group">
                                    <label>Identification attribute</label>
                                    <input type="text" formControlName="uid" class="form-control"/>
                                    <!--<control-message [control]="this.getMediaFormRef(media.key).controls.uid"></control-message>-->
                                  </div>
                                  <div class="form-group">
                                    <label>Link To Url</label>
                                    <input type="checkbox" formControlName="linkToUrl" (click)="addLinkToURL(mediaKey,$event)"/>
                                  </div>
                                  <div *ngIf="this.getMediaFormRef(mediaKey)['controls'].linkToUrl.value">
                                      <label>Link To Microsite</label>
                                      <input type="checkbox" formControlName="linkToMicrosite" (click)="addLinkToMicrosite(mediaKey,$event)"/>
                                      <div *ngIf="!this.getMediaFormRef(mediaKey)['controls'].linkToMicrosite.value">
                                        <label>Destination Url</label>
                                        <input type="text" formControlName="shareLink" placeholder="eg:url to microsite"/>
                                      </div>
                                  </div>
                                  <div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                    <div class="sectionTitle">Message</div>
                  <div class="card col-md-12">
                    <div class="card-body">
                      <button data-toggle="collapse" href="#emailMessageContent" role="button" aria-expanded="false"
                              aria-controls="emailMediaContent" type="button" class="btn btn-info ">Manage Message Content
                      </button>
                      <div class="collapse" id="emailMessageContent">
                        <button type="button" class="btn btn-success btn-sm" (click)="onEmailAddMessageContent()">
                          <span><i class="fas fa-plus"></i></span></button>
                          <div *ngFor="let msgKey of this.emailMessageForm.keys()" class="card mb-0">
                            <div class="card-header collapsed" data-toggle="collapse">
                              <a class="btn btn-primary btn-sm" data-toggle="collapse" href="#{{msgKey}}">
                                <h6>
                                  Message
                                </h6>
                              </a>
                              <button id="btnRemoveAccordion" (click)="onEmailRemoveMessageContent(msgKey)" type="button"
                                      class="btn btn-outline-danger btn-sm">Remove
                              </button>
                            </div>
                            <div id="{{msgKey}}" class="innerCollapse collapse">
                              <div class="card card-body">
                                <form [formGroup]=this.getMsgFormRef(msgKey)>
                                  <div class="form-group">
                                    <label>Message</label>
                                    <textarea formControlName="message" rows="10" cols="50" style="width:100%"></textarea>
                                    <!--<control-message [control]="this.getMsgFormRef(msg.key).controls.message"></control-message>-->
                                  </div>
                                  <div>
                                    <table formGroupName="textAppearance">
                                      <thead>
                                      <th>Font Color</th>
                                      <th>Font Size (px)</th>
                                      <th>Font Family</th>
                                      <th>Font Weight</th>
                                      </thead>
                                      <tbody>
                                      <tr>
                                        <td>
                                          <input style="width:100px;" type="color" formControlName="fontColor" class="form-control"/>
                                        </td>
                                        <td>
                                          <input style="width:100px;" type="number" min="10" max="100" formControlName="fontSize" class="form-control"/>
                                        </td>
                                        <td>
                                          <div class="btn-group">
                                            <input  style="width:140px;" type="text" [disabled]="true" class="btn btn-outline-primary" formControlName="fontFamily" class="form-control"/>
                                            <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false">
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                              <a class="dropdown-item" (click)="setFontFamily(msgKey,'arial')">Arial</a>
                                              <a class="dropdown-item" (click)="setFontFamily(msgKey,'comic')">Comic</a>
                                              <a class="dropdown-item" (click)="setFontFamily(msgKey,'microsoft')">Microsoft</a>
                                              <a class="dropdown-item" (click)="setFontFamily(msgKey,'ubuntu')">Ubuntu</a>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div class="btn-group">
                                            <input  style="width:140px;" type="text" [disabled]="true" class="btn btn-outline-primary" formControlName="fontWeight" class="form-control"/>
                                            <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false">
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                              <a class="dropdown-item" (click)="setFontWeight(msgKey,'normal')">Normal</a>
                                              <a class="dropdown-item" (click)="setFontWeight(msgKey,'bold')">Bold</a>
                                              <a class="dropdown-item" (click)="setFontWeight(msgKey,'bolder')">Bolder</a>
                                              <a class="dropdown-item" (click)="setFontWeight(msgKey,'lighter')">Lighter</a>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <div class="form-group">
                                    <label>Identifier</label>
                                    <input type="text" formControlName="uid" class="form-control"/>
                                    <!--<control-message [control]="this.getMsgFormRef(msg.key).controls.uid"></control-message>-->
                                  </div>
                                  <div class="form-group">
                                    <label>Clear Text</label>
                                    <input type="checkbox" formControlName="clearText"/>
                                  </div>
                                  <table formGroupName="textLinks">
                                    <thead>
                                    <tr>
                                      <td>Word</td>
                                      <td>Link</td>
                                      <td>Description</td>
                                      <td>Action</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                      <tr *ngFor="let item of this.getLinks(this.emailLanguage)">
                                        <td>{{item.link.texts.get(this.emailLanguage)}}</td>
                                        <td>{{item.link.links.get(this.emailLanguage)}}</td>
                                        <td>{{item.link.descriptions.get(this.emailLanguage)}}</td>
                                        <td>
                                          <button type="button" class="btn btn-danger " (click)="removeWord(item.link.texts.get(this.emailLanguage))"><span><i class="far fa-trash-alt"></i></span></button>
                                        </td>
                                      </tr>
                                    <tr>
                                      <td><input formControlName="word" class="form-control"></td>
                                      <td><input formControlName="hyperLink" class="form-control"></td>
                                      <td><input formControlName="description" class="form-control"></td>
                                      <td>
                                        <button type="button" class="btn btn-success " (click)="onAddMessageLink(msgKey)">Add</button>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>

                                </form>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="sectionTitle">Attachments</div>
                  <div class="card col-md-12">
                    <div class="card-body">
                      <button data-toggle="collapse" href="#collapseAttachments" role="button" aria-expanded="false"
                              aria-controls="collapseExample" type="button" class="btn btn-success">Manage Attachments
                      </button>
                      <div class="innerCollapse collapse" id="collapseAttachments">
                          <button type="button" class="btn btn-success btn-sm" (click)="onEmailAddAttachmentContent()">
                              <span><i class="fas fa-plus"></i></span>
                          </button>
                          <div *ngFor="let attach of this.attachments.keys()" class="card mb-0">
                              <div class="card-header collapsed" data-toggle="collapse">
                                  <a class="btn btn-primary btn-sm" data-toggle="collapse" data-parent="#accordion" href="#{{attach}}">
                                      <h6>
                                          Attachment
                                      </h6>
                                  </a>
                                  <button id="btnRemoveAccordion" (click)="onRemoveAttachement(attach)" type="button"
                                          class="btn btn-outline-danger btn-sm">Remove
                                  </button>
                              </div>
                              <div id="{{attach}}" class="innerCollapse collapse">
                                  <div class="card card-body">
                                      <form [formGroup]=this.getEmailAttachmentForm(attach)>
                                          <div class="form-group">
                                              <label>Question Number</label>
                                              <input type="text" formControlName="questionNo"  class="form-control"/>
                                          </div>
                                          <div class="form-group">
                                              <label>Choice Number</label>
                                              <input type="text" formControlName="choiceNo" class="form-control"/>
                                          </div>
                                          <div class="form-group">
                                              <label>New File Name</label>
                                              <input type="text" formControlName="questionType" class="form-control"/>
                                          </div>
                                      </form>
                                  </div>
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br/>
                  <div class="row">
                    <div class="sectionTitle">
                      Social Sharing
                    </div>
                    <div class="card col-md-12">
                      <div class="card-body">
                          <button data-toggle="collapse" href="#emailSocialContent" role="button" aria-expanded="false"
                                  aria-controls="emailSocialContent" type="button" class="btn btn-info ">Manage Social Content
                          </button>
                          <div class="collapse" id="emailSocialContent">
                            <button type="button" class="btn btn-success btn-sm" (click)="onEmailSharingSocialContent()">
                              <span><i class="fas fa-plus"></i></span></button>
                              <div *ngFor="let socialKey of this.emailSocialForm.keys()" class="card mb-0">
                                <div class="card-header collapsed" data-toggle="collapse">
                                  <a class="btn btn-primary btn-sm" data-toggle="collapse" data-parent="#accordion" href="#{{socialKey}}">
                                    <h6>
                                      Social Sharing Content
                                    </h6>
                                  </a>
                                  <button id="btnRemoveAccordion" type="button" class="btn btn-outline-danger btn-sm"
                                          (click)="onEmailRemoveSocialContent(socialKey)">Remove
                                  </button>
                                </div>
                                <div id="{{socialKey}}" class="innerCollapse collapse">
                                  <div class="card card-body">
                                    <form [formGroup]=this.getSocialFormRef(socialKey)>
                                      <div class="form-group">
                                        <div class="dropdown">
                                          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {{this.emailSocialForm.get(socialKey)['controls'].shareClass.value}}
                                          </button>
                                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a class="dropdown-item form-control" (click)="onSocialPlatformSelected('facebook',socialKey)"
                                               formControlname="shareClass">Facebook</a>
                                            <a class="dropdown-item form-control" (click)="onSocialPlatformSelected('twitter',socialKey)"
                                               formControlname="shareClass">Twitter</a>
                                            <a class="dropdown-item form-control" (click)="onSocialPlatformSelected('download',socialKey)"
                                               formControlname="shareClass">Download</a>
                                            <a class="dropdown-item form-control" (click)="onSocialPlatformSelected('website',socialKey)"
                                               formControlname="shareClass">Website</a>
                                          </div>
                                        </div>
                                        <table *ngIf="isValidSocialMedium(this.emailSocialForm.get(socialKey)['controls'].shareClass.value)">
                                          <tr>
                                            <div>Content To Share On Social Media</div>
                                          </tr>
                                          <tr>
                                            <div>
                                              <input style="width:20px;" type="radio" name="shareImage"
                                                     formControlName="shareImage" value="image"> Image
                                              <input style="width:20px;" type="radio" name="shareImage"
                                                     formControlName="shareImage" value="vimeo"> Vimeo
                                            </div>
                                          </tr>
                                          <tr *ngIf="this.getSocialFormRef(socialKey)['controls'].shareImage.value === 'image'">
                                            <div style="padding-left: 30px;">
                                              Select the photo question that you wish to share on social media.
                                              <table style="width:40%">
                                                <tr formGroupName="socialQuestion">
                                                  <ngx-select
                                                          formControlName="questionNo"
                                                              [allowClear]="false"
                                                              [items]="this.photoQuestions"
                                                              (select)="socialPhotoQuestionSelected($event,this.getSocialFormRef(socialKey)['controls'].shareClass.value)">
                                                  </ngx-select>
                                                </tr>
                                              </table>
                                            </div>
                                          </tr>
                                          <tr *ngIf="this.getSocialFormRef(socialKey)['controls'].shareImage.value === 'vimeo'">
                                            <div style="padding-left: 30px;">
                                              Select the video question that you wish to share on social media.
                                              <table style="width:40%">
                                                <tr formGroupName="socialQuestion">
                                                  <ngx-select
                                                             formControlName="questionNo"
                                                             [allowClear]="false"
                                                             [items]="this.vimeoQuestions"
                                                             (select)="socialVideoQuestionSelected($event,this.getSocialFormRef(socialKey)['controls'].shareClass.value)">
                                                  </ngx-select>
                                                </tr>
                                              </table>
                                            </div>
                                          </tr>
                                        </table>
                                      </div>
                                      <div *ngIf="isValidSocialMedium(this.emailSocialForm.get(socialKey)['controls'].shareClass.value)" class="form-group">
                                        <label>Social Media Message</label>
                                        <input type="text" formControlName="hashMessage" class="form-control"/>
                                      </div>
                                      <div class="form-group">
                                        <table>
                                          <tr>
                                            <td><label>Click Area</label></td>
                                            <td><input type="text" formControlName="clickArea"/></td>
                                          </tr>
                                          <tr *ngIf="this.emailSocialForm.get(socialKey)['controls'].shareClass.value!='download'">
                                            <td><label>Use As Url</label></td>
                                            <td><input type="checkbox" formControlName="useAsUrl"/></td>
                                          </tr>
                                          <tr *ngIf="this.emailSocialForm.get(socialKey)['controls'].shareClass.value!='download'">
                                            <td><label *ngIf="this.emailSocialForm.get(socialKey)['controls'].useAsUrl.value">Destination Url</label></td>
                                            <td>
                                              <input *ngIf="this.emailSocialForm.get(socialKey)['controls'].useAsUrl.value" type="text" formControlName="shareLink"
                                                     placeholder="eg:url to microsite"/>
                                            </td>
                                          </tr>
                                        </table>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>
                <br/>
                <div class="row">
                    <div class="sectionTitle">Email Conditions</div>
                  <div class="card col-md-12">
                    <div class="card-body">
                      <button data-toggle="collapse" href="#emailConditions" role="button" aria-expanded="false"
                              aria-controls="emailConditions" type="button" class="btn btn-info ">Manage Conditions
                      </button>
                      <div class="collapse" id="emailConditions">
                        <button type="button" class="btn btn-success btn-sm" (click)="onEmailAddConditionsContent()">
                          <span><i class="fas fa-plus"></i></span>
                        </button>
                          <ng-container *ngIf="this.emailConditions.length>0">
                              <br/>
                              <br/>
                              <label>SMS Conditions Logical Operator</label>
                              <ngx-select
                                      [allowClear]="false"
                                      [placeholder] = this.extractBooleanOperatorValue()
                                      [items]="this.conditionOperators"
                                      (select)="conditionLogicalOperatorSelected($event)">
                              </ngx-select>
                              <br/>
                              <br/>
                          </ng-container>
                          <div *ngFor="let key of this.emailConditions.keys()" class="card mb-0">
                            <div class="card-header collapsed" data-toggle="collapse">
                              <a class="btn btn-primary btn-sm" data-toggle="collapse" data-parent="#accordion" href="#{{key}}">
                                <h6>
                                  Condition
                                </h6>
                              </a>
                              <button id="btnRemoveAccordion" (click)="onEmailRemoveConditionContent(key)" type="button"
                                      class="btn btn-outline-danger btn-sm">Remove
                              </button>
                            </div>
                            <div id="{{key}}" class="innerCollapse collapse">
                              <div class="card card-body">
                                <form [formGroup]=this.getConditionFormRef(key)>
                                  <div class="form-group">
                                    <label>Question Number</label>
                                    <input type="text" formControlName="questionNo"  class="form-control"/>
                                  </div>
                                  <div class="form-group">
                                    <label>Choice Number</label>
                                    <input type="text" formControlName="choiceNo" class="form-control"/>
                                  </div>
                                  <div class="form-group">
                                    <label>Question Type</label>
                                    <input type="text" formControlName="questionType" class="form-control"/>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- footer-->
              <div class="modal-footer ">
                <button type="button" (click)="newEmailCreate()" class="btn btn-primary clickable hand" id="submit"><span
                  class="glyphicon glyphicon-floppy-disk"></span> {{'save' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <generic-info-modal (OkClick)="onOk()"></generic-info-modal>
    `
})
export class CreateEmailComponent extends AddFileToDownloadComponent implements OnInit, AfterViewInit, OnChanges {

    constructor(private _projectService: ProjectService, private _formBuilder:FormBuilder,@Inject(DOCUMENT) public document) {
        super(document);
        this.email = new Email();
        if(this.uploader != null) {
          this.uploader.clearQueue();
        }
    }


    definedTerminalType:number;
    @Input() hide = true;
    // tslint:disable-next-line:no-input-rename
    @Input('filesToDownload') fileToDownload:Array<FileToDownload>;
    @Input() project:Project;
    @Input() questionnaire:Questionnaire;

    @Input() terminal:Terminal;

    /*@Input() pId = 0;
    @Input() qId = 0;
    @Input() tId = 0;*/

    // @Input() refEmail:Email;


  @ViewChild(MaterialChipsInputComponent) materialTagChips:MaterialChipsInputComponent;




    // tslint:disable-next-line:no-input-rename
    @Output()NewEmailCreate: EventEmitter<any> = new EventEmitter();
    // tslint:disable-next-line:no-input-rename
    @Output()CancelCreateEmail: EventEmitter<any> = new EventEmitter();
    // tslint:disable-next-line:no-input-rename
    public uploader:FileUploader;
   // email concept
    // private email:Email = new Email();
    private emailLanguage:string;

    private emailMessage:TSMap<string, TextMessage> = new TSMap();

    private mediaContent:TSMap<string, EmailImage> = new TSMap();

    private emailMessageLinks:TSMap<string,ThirdPartyShare> = new TSMap();

    private emailSocialContent:TSMap<string, SocialMedia> = new TSMap();

    private emailBannerContent:TSMap<string, EmailBanner> = new TSMap();

    private emailConditions:TSMap<string,QuestionCondition> = new TSMap();

    private socialMediaSharingQuestions:TSMap<string,string> = new TSMap();

    private attachments:TSMap<string,Attachment> = new TSMap();

    // photo videos questions
    private photoQuestions:string[] = [];
    private vimeoQuestions:string[] = [];
    private conditionOperators:string[] =['AND','OR','XOR'];
    private selectedConditionOperator:BooleanOperator;

    private emailMediaForm:TSMap<string, FormGroup> =new TSMap();
    private emailMessageForm:TSMap<string, FormGroup> = new TSMap();
    private emailSocialForm:TSMap<string, FormGroup> = new TSMap();
    private emailConditionForm:TSMap<string, FormGroup> = new TSMap();
    private emailAttachmentForm:TSMap<string, FormGroup> = new TSMap();
    private emailForm:FormGroup;
    private emailDimensionsForm:FormGroup;
    private _errorMessage;

    @Input() flag:string;

    @Input() email:Email;

    private selectedLang:string;

    private langArr:string[];

    private bckSolidColor =true;

    public onEmailCreate(email: Email) {
        this._projectService.createEmail(email, this.project.id,this.questionnaire.id,this.terminal.id,this.definedTerminalType).subscribe(
            (msg) => {
                console.log(msg);
                // this.showGenericAlertMsgBox('Email has  been saved successfully !','Mail Creator',200);
                this.genericModal.defineModal('Email has  been saved successfully !','Mail Creator',200);
                this.genericModal.toggleModal();
                // this.hideDialog();
               // this.contentCreation  = true;
            });

    }

    ngOnInit():void {
        this.definedTerminalType = this.getTerminalTypeID();
        this.uploader = new FileUploader({
            url: ServerAddress.getInstance().getValue()+'upload-project-file',
            headers: [{name:'Accept', value:'application/json'}],
            autoUpload: true,
            method:'POST',
            authToken:localStorage.getItem('Authorization')

        });
        this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
        this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
        this.uploader.onBeforeUploadItem = (item) => {
            item.withCredentials = false;

        };




        // need to change this later with proper project terms
        this.uploader.onBuildItemForm = (item, form) => {
            item.formData =  [{ projectID:this.project.id, questionnaireID:this.project.questionnaires[0].id, terminalID:this.definedTerminalType }];
            form.append('projectID', this.project.id);
            form.append('questionnaireID', this.project.questionnaires[0].id);
            form.append('terminalID', this.definedTerminalType );
        };


        this.emailForm = this._formBuilder.group({
          language:['en'],
          template:['style1'],
          bgColor:['#FFFFFF'],
          bgImg:[''],
          emailExpediter:['noreply@nomadlogicapp.com'],
          emailSubject:['']
        });


        this.emailDimensionsForm = this._formBuilder.group({
            overallEmailWidth:[],
            emailImageWidth:[],
            emailImageHeight:[],
            emailTextPargrMargin:[],
            respondentPictureMaxWidth:[]
        });




        for(const  question of this.questionnaire.questions) {
            if(question.type === 'vimeo' || question.type === 'video') {
                this.vimeoQuestions.push(question.no + ' '+ question.texts.get('en'));
            }
            if(question.type === 'picture') {
                this.photoQuestions.push(question.no + ' '+ question.texts.get('en'));
            }
        }

        // retreive email form already available on the server
        // this.getEmail(this.getTerminalTypeID());
        this.prepareView();
    }

    //  TODO:deprecated
    private getEmail(typeId:number) {
       /* this._projectService.getEmail( this.project.id,this.questionnaire.id,this.terminal.id,typeId).subscribe((courier:any) => {

                if(courier!= null) {
                    this.email = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(courier,Email);
                    this.setValidLanguages();
                    this.loadEmailFormFromEmailModel(this.langArr[0]); // par defaut english
                    this.materialTagChips.setLanguageArray(this.langArr);
                    this.materialTagChips.setSelectedLanguage(this.emailLanguage);
                    this.materialTagChips.setId(this.emailLanguage);
                } else {
                    this.resetForms();
                }
            },
            error => this._errorMessage = <any>error);*/
    }

    private prepareView() {

        if(this.email!= null) {
            this.setValidLanguages();
            this.loadEmailFormFromEmailModel(this.langArr[0]); // par defaut english
            this.materialTagChips.setLanguageArray(this.langArr);
            this.materialTagChips.setSelectedLanguage(this.emailLanguage);
            this.materialTagChips.setId(this.emailLanguage);
        } else {
            this.resetForms();
        }
    }

    getLinks(lg:string):ThirdPartyShare[] {

      const arr:ThirdPartyShare[] = [];
      for(const key of this.emailMessageLinks.keys()) {
          if(this.emailMessageLinks.get(key).link.links.get(lg)!=null) {   // null also verifies undefined
            arr.push(this.emailMessageLinks.get(key));
          }
      }

      return arr;
    }


    private resetForms() {

        if(this.emailForm!=null) {
          this.emailForm.reset();
        }
        if(this.langArr!=null) {
            this.langArr.length =0;
        }
        this.materialTagChips.setLanguageArray(this.langArr);
        this.emailLanguage = '';

        for(const key of this.emailConditions.keys()) {
            this.emailConditionForm.get(String(key)).reset();
        }

        for(const key of this.attachments.keys()) {
            this.emailAttachmentForm.get(key).reset();
        }
        this.emailConditions.clear();
        this.email = new Email();
        this.emailMessageLinks.clear();

        for(const key of this.emailMessage.keys()) {
            if(this.emailMessageForm.get(key)!=null) {
                this.emailMessageForm.get(key).reset();
            }
        }

        for(const key of this.emailSocialContent.keys()) {
            if(this.emailSocialForm.get(key)!=null) {
                this.emailSocialForm.get(key).reset();
            }
        }

        for(const key of this.emailConditions.keys()) {
            if(this.emailConditionForm.get(key)!=null) {
                this.emailConditionForm.get(key).reset();
            }
        }
    }



    onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {

        console.log(response);

    }

    onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {

        console.log(response);
    }

    onEmailAddMediaContent() {
        let index;
        index = this.mediaContent.size();
        this.emailMediaForm.set('media'+index,this.getMediaForm());
        this.mediaContent.set('media'+index, new EmailImage());
    }

    onEmailAddConditionsContent() {
        let index;
        index = this.emailConditions.size();
        this.emailConditionForm.set('condition'+index,this.getConditionForm());
        this.emailConditions.set('condition'+index, new QuestionCondition());
    }

    onEmailAddAttachmentContent() {
        let index;
        index = this.attachments.size();
        this.emailAttachmentForm.set('attach'+index,this.getConditionForm());
        this.attachments.set('attach'+index, new Attachment());
    }


    // TODO: Need to come back on this. Add the events on the radio button directly
   /* ngOnChanges()
    {
        this.tryFillEmailModel();
    }*/

    public selected(value:any):void {
         this.emailForm['controls'].language.setValue(value);
         this.emailLanguage = value;
    }


    public socialVideoQuestionSelected(value: any, value1: string):void {
        if(value!=null) {
            // this.socialQuestion =  Number(value['text']);
        }
    }


    public socialPhotoQuestionSelected(value:any,shareClass:string):void {
        if(value!=null) {
            const arr = value.split(' ', 2);
            this.socialMediaSharingQuestions.set(shareClass,value);
        }
    }


    public refreshValue(value:any):void {
        // this.value = value;
    }


    public newEmailCreate() {

        this.uploader.clearQueue();
        // const email = new Email();
        console.log(this.emailForm);
        for(const item of this.emailMediaForm.keys()) {
          console.log(this.emailMediaForm.get(item));
        }
        for(const item of this.emailMessageForm.keys()) {
          console.log(this.emailMessageForm.get(item));
        }

        for(const item of this.emailSocialForm.keys()) {
          console.log(this.emailSocialForm.get(item));
        }

        console.log('emailBanner array');
        for(const item of this.emailBannerContent.keys()) {
          console.log(this.emailBannerContent.get(item));
        }

        this.uploader.clearQueue();
        console.log(JSON.stringify(this.fileToDownload));




        let found = false;

        this.email.language = this.emailLanguage;
        /*console.log('font family-> '+ this.email.fontFamily);
        console.log('font size -> '+ this.email.fontSize);
        console.log('font weight -> '+ this.email.fontWeight);
        console.log('font color -> '+ this.email.fontColor);*/
        if(this.bckSolidColor) {
          this.email.background_color = this.emailForm['controls'].bgColor.value;
          this.email.background_image=null;
        } else if(!this.bckSolidColor) {

          const str ='C:\\fakepath\\';
          const path = this.emailForm['controls'].bgImg.value.toString();
          this.email.background_image = this.emailForm['controls'].bgImg.value.toString().substr(str.length,path.length);
          this.email.background_color=null;
          console.log('email bg value ->' + this.email.background_image);
        }
        this.email.selectedCssTemplate = this.emailForm['controls'].template.value;
        this.email.expediter.set(this.email.language,this.emailForm['controls'].emailExpediter.value);
        this.email.subject.set(this.email.language,this.emailForm['controls'].emailSubject.value);

        const conditionsEvaluator = new MultipleCondition();
        conditionsEvaluator.setConditionClass('multiple');
        for(const key of this.emailConditions.keys()) {
          const questionCondition = new QuestionCondition();
          questionCondition.setQuestionNo(this.emailConditionForm.get(key)['controls'].questionNo.value);
          questionCondition.setChoiceNo(this.emailConditionForm.get(key)['controls'].choiceNo.value);
          questionCondition.type = this.emailConditionForm.get(key)['controls'].questionType.value;
          questionCondition.conditionClass = 'simple';
          conditionsEvaluator.addCondition(questionCondition);
        }
        conditionsEvaluator.setBooleanOperator(this.selectedConditionOperator);
        this.email.condition = conditionsEvaluator;


      for(const key of this.emailBannerContent.keys()) {
        let index = -1;
        index = this.email.emailBanners.findIndex(b => b.bannerName === key);
        if(index !== -1) {
          this.email.emailBanners.splice(index,1);
        }

        this.email.emailBanners.push(this.emailBannerContent.get(key));
      }

      for(const key of this.emailMediaForm.keys()) {
        let emailImage;
        if(this.email.blocks.blockImages.find(m => m.questionNo === this.emailMediaForm.get(key)['controls'].questionNo.value)) {
          emailImage = this.email.blocks.blockImages.find(m => m.questionNo === this.emailMediaForm.get(key)['controls'].questionNo.value);
          found = true;
        } else {
          emailImage = new EmailImage();
        }

        emailImage.questionNo = this.emailMediaForm.get(key)['controls'].questionNo.value;
        emailImage.choiceNo = this.emailMediaForm.get(key)['controls'].choiceNo.value;
        emailImage.linkToUrl = this.emailMediaForm.get(key)['controls'].linkToUrl.value;
        emailImage.linkToMicrosite = this.emailMediaForm.get(key)['controls'].linkToMicrosite.value;
        emailImage.uid = this.emailMediaForm.get(key)['controls'].uid.value;
        emailImage.imageWidth = this.emailMediaForm.get(key)['controls'].imageWidth.value;
        emailImage.imageHeight = this.emailMediaForm.get(key)['controls'].imageHeight.value;
        emailImage.externalLink.links.set(this.email.language,this.emailMediaForm.get(key)['controls'].shareLink.value);
        if(!found) {
          this.email.blocks.blockImages.push(emailImage);
        }
        found = false;
      }
      // flushed the array
      // this.email.blocks.blockTextMessages.length = 0;
      for(const key of this.emailMessageForm.keys()) {
        let emailText;
        if (this.email.blocks.blockTextMessages.find(m => m.uid === this.emailMessageForm.get(key)['controls'].uid.value)) {  // this.emailMessageForm.get(key)['controls'].uid.value
          emailText = this.email.blocks.blockTextMessages.find(m => m.uid === this.emailMessageForm.get(key)['controls'].uid.value); // this.emailMessageForm.get(key)['controls'].uid.value
          found = true;} else {
          emailText = new TextMessage();
         }

        emailText.texts.set(this.email.language,this.emailMessageForm.get(key)['controls'].message.value);
        emailText.clearText = this.emailMessageForm.get(key)['controls'].clearText.value;
        if(this.emailMessageForm.get(key)['controls'].uid.value==='') {
          emailText.uid = 'msg'+this.emailMessage.size()+1;
        } else {
          emailText.uid = this.emailMessageForm.get(key)['controls'].uid.value;
        }

        emailText.fontSize = this.emailMessageForm.get(key)['controls'].textAppearance['controls'].fontSize.value;
        emailText.fontColor = this.emailMessageForm.get(key)['controls'].textAppearance['controls'].fontColor.value;
        emailText.fontFamily = this.emailMessageForm.get(key)['controls'].textAppearance['controls'].fontFamily.value;
        emailText.fontWeight = this.emailMessageForm.get(key)['controls'].textAppearance['controls'].fontWeight.value;

        if(!found) {
          this.email.blocks.blockTextMessages.push(emailText);
          this.emailMessageForm.delete(key);
        }
        found = false;


      }

      Object.keys(this.emailDimensionsForm.controls).forEach((key:string)=> {
          switch (key) {
              case 'overallEmailWidth':this.email.dimensions.overallEmailWidth = this.emailDimensionsForm.get(key).value;break;
              case 'emailImageWidth':this.email.dimensions.emailImageWidth = this.emailDimensionsForm.get(key).value;break;
              case 'emailImageHeight':this.email.dimensions.emailImageHeight = this.emailDimensionsForm.get(key).value;break;
              case 'emailTextPargrMargin':this.email.dimensions.textPargrSideMargin = this.emailDimensionsForm.get(key).value;break;
              case 'respondentPictureMaxWidth':this.email.dimensions.respondentPictureMaxWidth = this.emailDimensionsForm.get(key).value;break;
          }
      });



      // Je suis rendu ici, recherche une maniere de deserializer le json.
      for(const key of this.emailMessageLinks.keys()) {
        if(this.email.links.has(key) === false) {
          this.email.links.set(key,this.emailMessageLinks.get(key));
        } else {
          if(this.email.links.get(key) == null) {
            continue;
          }
          this.email.links.get(key).link.links.set(this.emailLanguage,this.emailMessageLinks.get(key).link.links.get(this.emailLanguage));
          this.email.links.get(key).link.descriptions.set(this.emailLanguage, this.emailMessageLinks.get(key).link.descriptions.get(this.emailLanguage));
          this.email.links.get(key).link.texts.set(this.emailLanguage,this.emailMessageLinks.get(key).link.texts.get(this.emailLanguage));
        }
      }

      for(const key of this.emailSocialForm.keys()) {
          const type = this.emailSocialForm.get(key)['controls'].shareClass.value;
          const imageQuestion = new EmailImage();
          const externalLink = new ExternalLink();
          // noinspection JSAnnotator
          // const socialMedia:BaseSocial = new BaseSocial();


          externalLink.uid = 'shareLink';


          if(this.emailSocialForm.get(key)['controls'].socialQuestion['controls'].questionNo.value!=null) {
            imageQuestion.questionNo = this.emailSocialForm.get(key)['controls'].socialQuestion['controls'].questionNo.value[0].split(' ',1)[0] as number;
            imageQuestion.choiceNo = 1;// this.emailSocialForm.get(key)['controls'].socialQuestion['controls'].choiceNo.value;
          }


          let socialMedia;


          if(type === 'facebook' ) {
            if(this.email.socialSharing.find(s => s.shareClass==='facebook')!= null) {
              socialMedia = (this.email.socialSharing.find(s => s.shareClass==='facebook')) as Facebook;
              // found = true;
            } else {
              socialMedia = new Facebook();
            }




            socialMedia.clickArea = this.emailSocialForm.get(key)['controls'].clickArea.value;
            socialMedia.shareClass =  'facebook';
            socialMedia.link.links.set(this.email.language,this.emailSocialForm.get(key)['controls'].shareLink.value);
            socialMedia.shareImage = this.emailSocialForm.get(key)['controls'].shareImage.value;
            socialMedia.hashMessage.set(this.email.language,this.emailSocialForm.get(key)['controls'].hashMessage.value);

            if(this.socialMediaSharingQuestions.get('facebook')!=null) {
                const arr = this.socialMediaSharingQuestions.get('facebook').split(' ',2);
                imageQuestion.questionNo = Number(arr[0]);
                imageQuestion.tag = arr[1];

            }
            socialMedia.socialQuestion = imageQuestion;

            if(this.email.socialSharing.find(s => s.shareClass==='facebook')!= null) {
              const tmp = this.email.socialSharing.indexOf(this.email.socialSharing.find(s => s.shareClass==='facebook'),0);
              this.email.socialSharing.splice(tmp,1);

            }
             // if(!found) {
              this.email.socialSharing.push(socialMedia);
            /* }
            found = false;*/

          }

          if(type === 'twitter') {
             if(this.email.socialSharing.find(s => s.shareClass==='twitter')!= null) {
              socialMedia = this.email.socialSharing.find(s => s.shareClass==='twitter');
              // found = true;
            } else {
              socialMedia = new Twitter();
             }

            socialMedia.clickArea = this.emailSocialForm.get(key)['controls'].clickArea.value;
            socialMedia.shareClass =  'twitter';
            /*externalLink.links[this.email.language] = this.emailSocialForm.get(key)['controls'].shareLink.value;*/
            socialMedia.link.links.set(this.email.language,this.emailSocialForm.get(key)['controls'].shareLink.value);
            socialMedia.shareImage = this.emailSocialForm.get(key)['controls'].shareImage.value;
            socialMedia.hashMessage.set(this.email.language ,this.emailSocialForm.get(key)['controls'].hashMessage.value);
            socialMedia.upload_picture = true;

            if(this.socialMediaSharingQuestions.get('twitter')!=null) {
                const arr = this.socialMediaSharingQuestions.get('twitter').split(' ',2);
                imageQuestion.questionNo = Number(arr[0]);
                imageQuestion.tag = arr[1];
            }
            socialMedia.socialQuestion = imageQuestion;


            if(this.email.socialSharing.find(s => s.shareClass==='twitter')!= null) {
              const tmp = this.email.socialSharing.indexOf(this.email.socialSharing.find(s => s.shareClass==='twitter'),0);
              this.email.socialSharing.splice(tmp,1);

            }
            // if(!found) {
                this.email.socialSharing.push(socialMedia);
            /*} else {
                found = false;
            }*/

          }

          if(type === 'download') {
            if(this.email.socialSharing.find(s => s.shareClass==='download')!= null) {
              socialMedia = this.email.socialSharing.find(s => s.shareClass==='download');
              // found= true;
            } else {
              socialMedia = new Download();
             }

            socialMedia.clickArea = this.emailSocialForm.get(key)['controls'].clickArea.value;
            socialMedia.shareClass =  'download';
            socialMedia.link.links.set(this.email.language, this.emailSocialForm.get(key)['controls'].shareLink.value);
            socialMedia.shareImage = this.emailSocialForm.get(key)['controls'].shareImage.value;
            socialMedia.download_image = true;
            if(this.email.socialSharing.find(s => s.shareClass==='download')!= null) {
              const tmp = this.email.socialSharing.indexOf(this.email.socialSharing.find(s => s.shareClass==='download'),0);
              this.email.socialSharing.splice(tmp,1);

            }
              // if(!found) {
              this.email.socialSharing.push(socialMedia);/*} else {
                  found = false;
              }*/
          }

        if(type === 'website') {
          if(this.email.socialSharing.find(s => s.shareClass==='thirdPartyShare')!= null) {
            socialMedia = this.email.socialSharing.find(s => s.shareClass==='thirdPartyShare');
            // found = true;
          } else {
            socialMedia = new ThirdPartyShare();
          }

          socialMedia.clickArea = this.emailSocialForm.get(key)['controls'].clickArea.value;
          socialMedia.shareClass =  'thirdPartyShare';
          socialMedia.link.links.set(this.email.language, this.emailSocialForm.get(key)['controls'].shareLink.value);
          if(this.email.socialSharing.find(s => s.shareClass==='thirdPartyShare')!= null) {
            const tmp = this.email.socialSharing.indexOf(this.email.socialSharing.find(s => s.shareClass==='thirdPartyShare'),0);
            this.email.socialSharing.splice(tmp,1);

          }
           // if(!found) {
            this.email.socialSharing.push(socialMedia);
           /*} else {
                found = false;
            }*/
        }
      }

        const emailJson = Json2TypescriptUtil.getJsonConvertInstance().serializeObject(this.email,Email);

        console.log(emailJson);
        // this.NewEmailCreate.emit(this.email);
        this.onEmailCreate(this.email);
    }

  onEmailRemoveMediaContent(key: string) {
      this.mediaContent.delete(key);
      this.emailMediaForm.delete(key);

      let idx;
      for(const msg of this.email.blocks.blockImages) {
          if(msg.uid === key) {
              idx = this.email.blocks.blockImages.indexOf(msg);
          }
      }
      this.email.blocks.blockImages.splice(idx,1);
  }

  onEmailRemoveConditionContent(key: string) {
    this.emailConditions.delete(key);
    this.emailConditionForm.delete(key);
  }

  onEmailAddMessageContent() {
    const index = this.emailMessage.size()+1;
    this.emailMessageForm.set('msg'+index,this.getMessageForm());
    this.emailMessage.set('msg'+index, new TextMessage());
  }

  onAddMessageLink(key:string) {
      let thirdParty;
      if(this.emailMessageLinks.has(this.emailMessageForm.get(key)['controls'].textLinks['controls'].word.value)) {
        thirdParty = this.emailMessageLinks.get(this.emailMessageForm.get(key)['controls'].textLinks['controls'].word.value);
      } else {
        thirdParty = new ThirdPartyShare();
      }

    thirdParty.link.links.set(this.emailLanguage,this.emailMessageForm.get(key)['controls'].textLinks['controls'].hyperLink.value);
    thirdParty.link.texts.set(this.emailLanguage,this.emailMessageForm.get(key)['controls'].textLinks['controls'].word.value);
    thirdParty.link.descriptions.set(this.emailLanguage,this.emailMessageForm.get(key)['controls'].textLinks['controls'].description.value);
    thirdParty.link.uid = 'messageLinks';



    this.emailMessageLinks.set(this.emailMessageForm.get(key)['controls'].textLinks['controls'].word.value,thirdParty);
  }

public setFontWeight(key:string,val:string) {
  // this.emailMessage.get(key).fontWeight = val;
  this.emailMessageForm.get(key)['controls'].textAppearance['controls'].fontWeight.setValue(val);
      /*for(const texts of this.email.blocks.blockTextMessages) {
        this.emailMessageForm.get(key)['controls'].textAppearance['controls'].fontWeight.setValue(val);
        if(texts.uid === key) {
          texts.fontWeight = val;
        }
      }*/

}

public setFontFamily(key:string,val:string) {
      // this.emailMessage.get(key).fontFamily = val;
  this.emailMessageForm.get(key)['controls'].textAppearance['controls'].fontFamily.setValue(val);
      /*for(const texts of this.email.blocks.blockTextMessages) {
        if(texts.uid === key) {
          texts.fontFamily = val;
        }
      }*/
}
getMediaForm() {
      return this._formBuilder.group(
        {
          questionNo:['',ValidationService.questionAndChoiceValidation],
          choiceNo:['',ValidationService.questionAndChoiceValidation],
          uid:['',Validators.maxLength(12)],
          linkToUrl:[false,null],
          linkToMicrosite:[false,null],
          shareLink:[],
          imageWidth:['',Validators.pattern('/\\d+')],
          imageHeight:['',Validators.pattern('/\\d+')],
        }
      );

  }

  getConditionForm() {
    return this._formBuilder.group(
      {questionNo:['',ValidationService.questionAndChoiceValidation],
        choiceNo:['',ValidationService.questionAndChoiceValidation],
        questionType:['',Validators.maxLength(12)]
      }
    );

  }

    getAttachementForm() {
        return this._formBuilder.group(
            {questionNo:['',ValidationService.questionAndChoiceValidation],
                choiceNo:['',ValidationService.questionAndChoiceValidation],
                newFileName:['',Validators.maxLength(12)]
            }
        );

    }


  getMessageForm() {
    return this._formBuilder.group(
      {message:['',Validators.minLength(10)],
        uid:['',Validators.maxLength(12)],
        clearText:[false],
        textAppearance: this._formBuilder.group({
          fontColor:[],
          fontSize:[],
          fontFamily:[],
          fontWeight:[]
        }),
        textLinks: this._formBuilder.group({
          word:[],
          hyperLink:[],
          description:[]
        })
      }
    );

  }

  getSocialSharingForm() {
    return this._formBuilder.group(
      {
          mediaContentToShare:[],
          clickArea:[],
          shareImage:['image'],
          hashMessage:[],
          shareClass:['Mean of Social Sharing'],
          useAsUrl:['false'],
          configFile:[],
          shareLink:[],
          linkToMicrosite:[],
        socialQuestion:this._formBuilder.group({
          questionNo:[],
          choiceNo:[],
        })
      }
    );
  }


  getMsgFormRef(key:string):FormGroup {
    return this.emailMessageForm.get(key);
  }

  getMediaFormRef(key:string):FormGroup {
      return this.emailMediaForm.get(key);
  }

  getConditionFormRef(key:string):FormGroup {
    return this.emailConditionForm.get(key);
  }

  getEmailAttachmentForm(key:string):FormGroup {
      return this.emailAttachmentForm.get(key);
  }

  getSocialFormRef(key:string):FormGroup {
      return this.emailSocialForm.get(key);
  }

  getEmailFormRef() {
    return this.emailForm;
  }

  getEmailDimensionsFormRef() {
        return this.emailDimensionsForm;
  }

  removeWord(key: any) {
    this.emailMessageLinks.delete(key);
      let idx;
      for(const val of this.email.links.keys()) {
          if(val === key) {
              idx = this.email.links.delete(val);
          }
      }
  }

  onEmailRemoveMessageContent(key: any):void {
    this.emailMessageForm.delete(key);
    this.emailMessage.delete(key);
    let idx;
    for(const msg of this.email.blocks.blockTextMessages) {
        if(msg.uid === key) {
             idx = this.email.blocks.blockTextMessages.indexOf(msg);
        }
    }
      this.email.blocks.blockTextMessages.splice(idx,1);
  }

  onEmailSharingSocialContent():void {
    const index = this.emailSocialForm.size()+1;
    this.emailSocialForm.set('social'+index,this.getSocialSharingForm());
  }

  onEmailRemoveSocialContent(key: any):void {
    this.emailSocialForm.delete(key);
  }

  onBannerSelected(file: FileItem, placement: string):void {
      const emailBanner = new EmailBanner();
      emailBanner.position = placement;
      emailBanner.bannerName = file.file.name;
      emailBanner.size = file.file.size;
      emailBanner.lang = this.emailLanguage;
      this.emailBannerContent.set(file.file.name,emailBanner);
  }

  onBannerPositionChanged(banner:EmailBanner, placement: string):void  {
      banner.position = placement;
      this.emailBannerContent.set(banner.bannerName,banner);
  }

  removeBannerFromUploaderQueue(file: FileItem):void {
    this.uploader.removeFromQueue(file);
  }

  removeBannerFromEmailBannerContent(file:EmailBanner):void {
    console.log(file.bannerName);
    this.emailBannerContent.delete(file.bannerName);
    const index = this.email.emailBanners.indexOf(file);
    this.email.emailBanners.splice(index,1);
  }

  onSocialPlatformSelected(socialPlatform: string,key:string):void {
    this.emailSocialForm.get(key)['controls'].shareClass.setValue(socialPlatform);
  }

  hideDialog() {
    // this.email = new Email();
    // this.CancelCreateEmail.emit();
    this.prepareView();
    this.resetForms();
    this.hide = true;
  }

  show(email:Email) {
      this.email = email;
      this.prepareView();
      // alert(this.flag);
      // this.flag = 'closed';
      this.hide = false;
  }

  ngAfterViewInit() {
  }

  toggleEmailBckOption() {
      this.bckSolidColor = !this.bckSolidColor;
  }

  private setValidLanguages() {
      this.langArr = this.email.subject.keys(); // Object.keys(this.email.subject);
  }

  loadEmailFormFromEmailModel(lg:string) {

    this.emailLanguage = lg;

    console.log(this.emailLanguage);
    console.log(lg);


    this.emailForm['controls'].template.setValue(this.email.selectedCssTemplate);


    this.emailForm['controls'].language.setValue(lg);
    if(this.email.background_color!=null) {
      this.emailForm['controls'].bgColor.setValue(this.email.background_color);
      this.bckSolidColor = true;
    }
    if(this.email.background_image!=null) {
      this.emailForm['controls'].bgImg.setValue(this.email.background_image);
      this.bckSolidColor = false;
    }
    this.emailForm['controls'].template.setValue(this.email.selectedCssTemplate);
    this.emailForm['controls'].emailSubject.setValue(this.email.subject.get(lg));

    this.emailForm['controls'].emailExpediter.setValue(this.email.expediter.get(lg));


    this.emailDimensionsForm['controls'].overallEmailWidth.setValue(this.email.dimensions.overallEmailWidth);
    this.emailDimensionsForm['controls'].emailImageWidth.setValue(this.email.dimensions.emailImageWidth);
    this.emailDimensionsForm['controls'].emailImageHeight.setValue(this.email.dimensions.emailImageHeight);
    this.emailDimensionsForm['controls'].emailTextPargrMargin.setValue(this.email.dimensions.textPargrSideMargin);
    this.emailDimensionsForm['controls'].respondentPictureMaxWidth.setValue(this.email.dimensions.respondentPictureMaxWidth);


    let x =0;
    for(const msg of this.email.blocks.blockTextMessages) {
      this.emailMessageForm.set(msg.uid,this.getMessageForm());
      this.emailMessage.set(msg.uid,msg);
      this.emailMessageForm.get(msg.uid)['controls'].message.setValue(msg.texts.get(lg));
      this.emailMessageForm.get(msg.uid)['controls'].uid.setValue(msg.uid);
      this.emailMessageForm.get(msg.uid)['controls'].clearText.setValue(msg.clearText);
      this.emailMessageForm.get(msg.uid)['controls'].textAppearance['controls'].fontColor.setValue(msg.fontColor);
      this.emailMessageForm.get(msg.uid)['controls'].textAppearance['controls'].fontSize.setValue(msg.fontSize);
      this.emailMessageForm.get(msg.uid)['controls'].textAppearance['controls'].fontFamily.setValue(msg.fontFamily);
      this.emailMessageForm.get(msg.uid)['controls'].textAppearance['controls'].fontWeight.setValue(msg.fontWeight);
      x++;
    }

    for(const attachment of this.email.attachments.keys()) {
        this.attachments.set(attachment,this.email.attachments.get(attachment));
    }

    let thirdParty: ThirdPartyShare;
    for(const key of this.email.links.keys()) {// const [key, value] of Object.entries(this.email.links)) {
      if(this.emailMessageLinks.get(key)!=null) {
         thirdParty = this.emailMessageLinks.get(key);
      } else {
         thirdParty = new ThirdPartyShare();
       }
      console.log(key);
      thirdParty.link.links.set(lg,this.email.links.get(key).link.links.get(lg));
      thirdParty.link.texts.set(lg,this.email.links.get(key).link.texts.get(lg));
      thirdParty.link.descriptions.set(lg,this.email.links.get(key).link.descriptions.get(lg));
      thirdParty.link.uid = 'messageLinks';

      this.emailMessageLinks.set(key,thirdParty);
      x++;
    }

    // nthis.email.links = this.emailMessageLinks;


    x =0;
    for(const media of this.email.blocks.blockImages) {
      this.emailMediaForm.set('media' + x, this.getMediaForm());
      this.mediaContent.set('media' + x, new EmailImage());

      this.emailMediaForm.get('media' + x)['controls'].questionNo.setValue(media.questionNo);
      this.emailMediaForm.get('media' + x)['controls'].choiceNo.setValue(media.choiceNo);
      this.emailMediaForm.get('media' + x)['controls'].linkToUrl.setValue(media.linkToUrl);
      this.emailMediaForm.get('media' + x)['controls'].uid.setValue(media.uid);
      this.emailMediaForm.get('media' + x)['controls'].shareLink.setValue(media.externalLink.links.get(lg));
      this.emailMediaForm.get('media' + x)['controls'].imageWidth.setValue(media.externalLink.links.get(lg));
      this.emailMediaForm.get('media' + x)['controls'].imageHeight.setValue(media.externalLink.links.get(lg));
      x++;
    }
    x =0;

    let socialFeature;
    for(const social of this.email.socialSharing) {
      if(social.shareClass === 'facebook') {
        socialFeature = social as Facebook;
        this.emailSocialForm.set('social' + x, this.getSocialSharingForm());
        this.socialMediaSharingQuestions.set('facebook',socialFeature.socialQuestion.questionNo + ' '+  socialFeature.socialQuestion.tag);
        this.emailSocialForm.get('social' + x)['controls'].socialQuestion['controls'].questionNo.setValue(socialFeature.socialQuestion.questionNo + ' '+  socialFeature.socialQuestion.tag);
        this.emailSocialForm.get('social' + x)['controls'].shareClass.setValue(socialFeature.shareClass);
        this.emailSocialForm.get('social' + x)['controls'].clickArea.setValue(socialFeature.clickArea);
        this.emailSocialForm.get('social' + x)['controls'].shareLink.setValue(socialFeature.link.links.get(lg));
        this.emailSocialForm.get('social' + x)['controls'].shareImage.setValue(socialFeature.shareImage);
        this.emailSocialForm.get('social' + x)['controls'].hashMessage.setValue(socialFeature.hashMessage.get(lg));
        this.emailSocialForm.get('social' + x)['controls'].useAsUrl.setValue(((social as Facebook).link.links.length!==0));
        x++;
      } else if(social.shareClass === 'twitter') {
        socialFeature = social as Twitter;
        this.emailSocialForm.set('social' + x, this.getSocialSharingForm());
        this.emailSocialForm.get('social' + x)['controls'].shareClass.setValue(socialFeature.shareClass);
          this.socialMediaSharingQuestions.set('facebook',socialFeature.socialQuestion.questionNo + ' '+  socialFeature.socialQuestion.tag);
        this.emailSocialForm.get('social' + x)['controls'].socialQuestion['controls'].questionNo.setValue(socialFeature.socialQuestion.questionNo + ' '+  socialFeature.socialQuestion.tag);
        this.emailSocialForm.get('social' + x)['controls'].clickArea.setValue(socialFeature.clickArea);
        this.emailSocialForm.get('social' + x)['controls'].shareLink.setValue(socialFeature.link.links.get(lg));
        this.emailSocialForm.get('social' + x)['controls'].shareImage.setValue(socialFeature.shareImage);
        this.emailSocialForm.get('social' + x)['controls'].hashMessage.setValue(socialFeature.hashMessage.get(lg));
        this.emailSocialForm.get('social' + x)['controls'].useAsUrl.setValue(((social as Twitter)._use_media_as_url));
        // socialMedia.upload_picture = true;
        x++;
      } else if(social.shareClass === 'download') {
        socialFeature = social as Download;
        this.emailSocialForm.set('social' + x, this.getSocialSharingForm());
        this.emailSocialForm.get('social' + x)['controls'].shareClass.setValue(socialFeature.shareClass);
        this.emailSocialForm.get('social' + x)['controls'].clickArea.setValue(socialFeature.clickArea);
        this.emailSocialForm.get('social' + x)['controls'].shareLink.setValue(socialFeature.link.links.get(lg));
        this.emailSocialForm.get('social' + x)['controls'].shareImage.setValue(socialFeature.shareImage);
        // socialMedia.download_image = true;
        x++;
      } else if(social.shareClass === 'thirdPartyShare') {
        socialFeature = social as ThirdPartyShare;
        this.emailSocialForm.set('social' + x, this.getSocialSharingForm());
        this.emailSocialForm.get('social' + x)['controls'].shareClass.setValue('website');
        this.emailSocialForm.get('social' + x)['controls'].clickArea.setValue(socialFeature.clickArea);
        this.emailSocialForm.get('social' + x)['controls'].shareLink.setValue(socialFeature.link.links.get(lg));
      }
    }

    x = 0;
      if(this.email.condition.conditionClass ==='multiple') {
          const multipleCond = this.email.condition as MultipleCondition;
          const conditionsArr = multipleCond.getConditions();

          this.selectedConditionOperator = multipleCond.getBooleanOperator();

          for(const cond of conditionsArr) {
              if(cond.conditionClass === 'simple') {
                  const condi = cond as QuestionCondition;
                  this.emailConditionForm.set('condition' + x, this.getConditionForm());
                  this.emailConditionForm.get('condition' + x)['controls'].questionNo.setValue(condi.getQuestionNo());
                  this.emailConditionForm.get('condition' + x)['controls'].choiceNo.setValue(condi.getChoiceNo());
                  this.emailConditionForm.get('condition' + x)['controls'].questionType.setValue(condi.type);
                  this.emailConditions.set('condition' + x, condi);
              }
              x++;
          }
      }

      x = 0;
      const attachmentsMap = this.email.attachments;
      for(const attach of attachmentsMap.keys()) {
          this.emailAttachmentForm.set('attach'+x, this.getAttachementForm());
          this.emailAttachmentForm.get('attach'+x)['controls'].questionNo.setValue(attachmentsMap.get(attach).question_no);
          this.emailAttachmentForm.get('attach'+x)['controls'].choiceNo.setValue(attachmentsMap.get(attach).choice_no);
          this.emailAttachmentForm.get('attach'+x)['controls'].newFileName.setValue(attachmentsMap.get(attach).new_file_name);
          this.attachments.set('attach'+x, attachmentsMap.get(attach));
          x++;
      }
  }


    ngOnChanges(changes: SimpleChanges): void {
        // this.getEmail(this.getTerminalTypeID());changes.email.currentValue.templateId
       // this.prepareView();
       this.definedTerminalType = this.getTerminalTypeID();
    }

    private getTerminalTypeID():number {
        if(this.terminal !=null) {
            return this.terminal.type === 'Android' ? 2 : 1;
        }
    }

    onRemoveAttachement(key: string) {
        this.attachments.delete(key);
        this.emailAttachmentForm.delete(key);
    }

    private conditionLogicalOperatorSelected(value: string) {
        switch(value) {
            case 'AND':this.selectedConditionOperator = BooleanOperator.AND;break;
            case 'OR':this.selectedConditionOperator = BooleanOperator.OR;break;
            case 'XOR':this.selectedConditionOperator = BooleanOperator.XOR;break;
            default: this.selectedConditionOperator = BooleanOperator.AND;break;
        }
    }

    private extractBooleanOperatorValue():string {
        return BooleanOperator[this.selectedConditionOperator];
    }

    private isValidSocialMedium(val:string) {
        if(val!=='website' &&  val!=='download' ) {
            return true;
        }
        return false;
    }

    addLinkToURL(mediaKey: string,obj:any) {
        this.getMediaFormRef(mediaKey)['controls'].linkToUrl.setValue(obj.target.checked);
    }

    addLinkToMicrosite(mediaKey: string,obj:any) {
        this.getMediaFormRef(mediaKey)['controls'].linkToMicrosite.setValue(obj.target.checked);
    }
}
